import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import _get from 'lodash/get';

import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

export const isEscapeKey = (key: string): boolean => key === 'Escape';

export interface GridPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  open: boolean;
  api?: {
    current?: {
      hidePreferences?: () => void;
      columnHeadersElementRef?: {
        current?: {};
      };
    };
  };
}

const useStyles = makeStyles(
  (theme: any) => ({
    rootPopper: {
      zIndex: theme.zIndex.modal,
      left: `${theme.spacing(15)}px !important`,
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      minWidth: 300,
      maxHeight: 450,
      display: 'flex',
    },
  }),
  { name: 'MuiDataGridPanel' },
);

const CustomGridPanel = React.forwardRef<HTMLDivElement, GridPanelProps>(function GridPanel(
  props,
  ref,
) {
  const { children, open, api } = props;
  const classes = useStyles();
  const hidePreferences = _get(api, 'current.hidePreferences');
  const columnHeadersElementRef = _get(api, 'current.columnHeadersElementRef');

  const handleClickAway = React.useCallback(() => {
    hidePreferences();
  }, [hidePreferences]);

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent) => {
      if (isEscapeKey(event.key)) {
        hidePreferences();
      }
    },
    [hidePreferences],
  );

  let anchorEl;
  if (columnHeadersElementRef && columnHeadersElementRef.current) {
    anchorEl = columnHeadersElementRef.current;
  }

  if (!anchorEl) {
    return null;
  }

  return (
    <Popper
      ref={ref}
      placement="top-start"
      className={classes.rootPopper}
      open={open}
      anchorEl={anchorEl}
      modifiers={{ flip: { enabled: false } }}
    >
      <ClickAwayListener onClickAway={handleClickAway}>
        <Paper className={classes.paper} elevation={8} onKeyDown={handleKeyDown}>
          {children}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
});

export default CustomGridPanel;
